import { render } from "./CreateAgendaView.vue?vue&type=template&id=77cf1ac2"
import script from "./CreateAgendaView.vue?vue&type=script&lang=js"
export * from "./CreateAgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__